import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ThemeProvider } from "@mui/material/styles";
import { BrowserRouter } from "react-router-dom";
import theme from "./styles/theme";
import CssBaseline from "@mui/material/CssBaseline";
import { AuthProvider } from "./hooks/use-auth";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

// One styling engine: MUI on Emotion. The app previously shipped both Emotion
// and styled-components, with the theme reaching only the former.
root.render(
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <AuthProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </AuthProvider>
  </ThemeProvider>
);

reportWebVitals(console.log);
